<template>
    <div class="deviceCheck">
        <el-steps :active="stepsActive" align-center>
            <el-step title="浏览器检测" description="检查当前浏览器是否兼容"></el-step>
            <el-step title="摄像头检测" description="检查当前电脑摄像头是否可用"></el-step>
            <el-step title="麦克风检测" description="检查当前电脑麦克风是否可用"></el-step>
            <el-step title="扬声器检测" description="检查当前电脑扬声器是否可用"></el-step>
            <el-step v-if="type == 'teacher'" title="屏幕分享" description="用于上课视频录制以及图片截取"></el-step>
        </el-steps>
        <div v-if="stepsActive == 0">
            <div :class="step1PassStatus? 'step1Box pass' : 'step1Box'">
                <span :class="step1PassStatus? 'pass' : ''">{{ step1 }}</span>
                <span class="userAgentBox" v-if="!step1PassStatus">{{ userAgent }}</span>
            </div>
            <div class="btnBox">
                <el-button type="primary" round @click="stepsActive++">下一步</el-button>
            </div>
        </div>
        <div v-show="stepsActive == 1">
            <div class="step2Box">
                <span v-if="attentionShow == 2" class="attention">注意：暂时无法访问摄像头，请确保当前没有其他应用请求访问摄像头，并重试。</span>
                <div id="stream" class="stream"></div>
                <div class="step2Content">
                    <el-select v-model="cameasActive" placeholder="请选择" @change="changeVideo">
                        <el-option
                         v-for="(item, index) in cameras"
                         :key="index"
                         :label="item.label"
                         :value="item.deviceId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="btnBox" v-if="attentionShow == 1">
                <el-button type="primary" round @click="stepsActive++">下一步</el-button>
            </div>
        </div>
        <div v-if="stepsActive == 2">
            <div class="step3Box">
                <span v-if="attentionShow == 2" class="attention">注意：暂时无法访问麦克风，请确保当前没有其他应用请求访问麦克风，并重试。</span>
                <div class="microphonesBox">
                    <div class="volumebar">
                        <span>输出</span>
                        <el-progress
                         :percentage="percentageNum" 
                         :show-text="false"></el-progress>
                    </div>
                </div>
                <div class="step3Content">
                    <el-select v-model="microphonesActive" placeholder="请选择" @change="changeAudio">
                        <el-option
                         v-for="(item, index) in microphones"
                         :key="index"
                         :label="item.label"
                         :value="item.deviceId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="btnBox" v-if="attentionShow == 1">
                <el-button type="primary" round @click="stepsActive++">下一步</el-button>
            </div>
        </div>
        <div v-if="stepsActive == 3">
            <div class="step4Box">
                <el-select v-model="loudspeakerActive" placeholder="请选择" @change="changeloudspeaker">
                    <el-option
                        v-for="(item, index) in loudspeakers"
                        :key="index"
                        :label="item.label"
                        :value="item.deviceId">
                    </el-option>
                </el-select>
                <el-button v-if="loudspeakerStatus" @click="handlerDeviceAudio('stop')">停止检测</el-button>
                <el-button v-else @click="handlerDeviceAudio('play')">检测扬声器</el-button>
                <audio ref="deviceAudio" src="@/assets/audio/device_check.mp3"></audio>
            </div>
            <div class="btnBox">
                <el-button type="primary" round @click="stopDeviceAudio">{{ type == 'teacher'? '下一步' : '进入教室' }}</el-button>
            </div>
        </div>
        <div v-if="stepsActive == 4">
            <div class="step5Box">
                设备检测通过之后每一次上课进入教室时都会弹出屏幕分享弹窗，用于上课视频录制以及图片截取
            </div>
            <div class="btnBox">
                <el-button @click="$emit('changeLiveCheck')">进入教室</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['changeLiveCheck', 'type', 'stepsIndex'],
    data() {
        return {
            stepsActive: this.stepsIndex,
            step1: "",
            step1PassStatus: false,
            cameraStream: "",
            cameras: [], //摄像头列表
            cameasActive: "", //当前选中的摄像头
            attentionShow: 0, // 0: 初十状态、1：获取成功、2：获取失败
            microphones: [], //麦克风列表
            microphonesActive: "", //当前选中的麦克风
            microphonesInterval: "",
            percentageNum: 0, //输出音量
            step3: "",
            screenShareShow: false, //分享
            loudspeakers: [], //扬声器列表
            loudspeakerActive: "",
            loudspeakerStatus: false,
            userAgent: window.navigator.userAgent
        }
    },
    created() {
        this.browserCheck();
        if(this.stepsIndex == 1) {
            this.getCameras(); 
        }
    },
    watch: {
        stepsActive() {
            if(this.microphonesInterval) {
                clearInterval(this.microphonesInterval)
                this.microphonesInterval = "";
            }
            if(this.stepsActive == 1) {
                this.$nextTick(() => {
                    this.getCameras();
                })
            } else if(this.stepsActive == 2) {
                this.$nextTick(() => {
                    this.getMicrophones();
                })
            }
        }, 
    },
    methods: {
        //检查浏览器是否兼容
        browserCheck() {
            TRTC.checkSystemRequirements().then((result) => {
                console.log(result)
                if(result) {
                    this.step1 = "您的浏览器兼容直播课堂，请点击下一步继续检测"
                    this.step1PassStatus = true;
                } else {
                    if(this.userAgent.indexOf('Chrome') > -1) {
                        this.step1 = `您的浏览器版本太低不兼容直播课堂，请升级浏览器版本`;
                        this.step1PassStatus = false;
                    } else if(this.userAgent.indexOf('Mac') > -1) {
                        this.step1 = `您的浏览器版本太低不兼容直播课堂，请升级浏览器或下载最新版本谷歌浏览器`;
                        this.step1PassStatus = false;
                    } else {
                        this.step1 = `您的浏览器不兼容直播课堂，请下载最新版谷歌浏览器或Chrome内核浏览器`;
                        this.step1PassStatus = false;
                    }
                }
            });
        },
        //检查摄像头
        getCameras() {
            this.cameraStream = TRTC.createStream({
                audio: true,
                video: true
            });
            // 设置视频分辨率等参数
            this.cameraStream.setVideoProfile('180p');
            this.cameraStream.initialize().then(() => {
                this.attentionShow = 1;
                var localVideoWrapEl = document.getElementById('stream');
                if (!localVideoWrapEl) {
                    localVideoWrapEl = document.createElement('div');
                    localVideoWrapEl.id = 'screen';
                    localVideoWrapEl.style.width = '100%';
                    localVideoWrapEl.style.height = '100%';
                    document.querySelector("#video_teacher_list").insertBefore(localVideoWrapEl, null);
                }
                // 本地流播放
                this.cameraStream.play(localVideoWrapEl, {
                    muted: true
                });
                TRTC.getCameras().then((devices) => { 
                    this.cameras = devices;
                    this.cameasActive = devices[0].label;
                })
                TRTC.getMicrophones().then((devices) => { 
                    this.microphones = devices;
                    this.microphonesActive = devices[0].label;
                })
                TRTC.getSpeakers().then((devices) => { 
                    this.loudspeakers = devices;
                    this.loudspeakerActive = devices[0].label;
                })
            }).catch((error) => {
                console.log(error)
                this.attentionShow = 2;
                // 本地流初始化失败
                // switch (error.name) {
                //     case 'NotReadableError':
                //     // 提示用户：暂时无法访问摄像头/麦克风，请确保当前没有其他应用请求访问摄像头/麦克风，并重试。
                //     break;
                //     default:
                //     console.error(error);
                //     break;
                // }
            })
        },
        //切换视频设置
        changeVideo(deviceId) {
            this.cameraStream.switchDevice('video', deviceId).then(() => {
                // camera切换成功
                console.log("camera切换成功")
            });
        },
        //检查麦克风
        getMicrophones() {
            clearInterval(this.microphonesInterval)
            this.microphonesInterval = setInterval(() => {
                this.percentageNum = this.cameraStream.getAudioLevel() * 400 > 100? 100 : this.cameraStream.getAudioLevel() * 400;
            }, 100);
        },
        //切换麦克风
        changeAudio(deviceId) {
            this.cameraStream.switchDevice('audio', deviceId).then(() => {
                // camera切换成功
                console.log("audio 切换成功")
            });
        },
        //切换扬声器
        changeloudspeaker(deviceId) {
            this.cameraStream.setAudioOutput(deviceId).then(() => {
                console.log("loudspeaker 切换成功")
            })
        },
        //扬声器检测
        handlerDeviceAudio(type) {
            if(type == 'play') {
                this.loudspeakerStatus = true;
                this.$refs.deviceAudio.play();
            } else {
                this.loudspeakerStatus = false;
                this.$refs.deviceAudio.pause();
            }
        },
        stopDeviceAudio() {
            this.$refs.deviceAudio.pause();
            if(this.type == 'teacher') {
                this.stepsActive++;
            } else {
                this.$emit('changeLiveCheck');
            }
        },
        //完成检测
        accomplish() {
            // this.$emit('changeLiveCheck');
        },
        //检查屏幕分享
        // isScreenShareSupported() {
        //     if(TRTC.isScreenShareSupported()) {
        //         this.step3 = "当前浏览器支持屏幕分享";
        //         this.screenShareShow = true;
        //     } else {
        //         this.step3 = "当前浏览器不支持屏幕分享"
        //         this.screenShareShow = false;
        //     }
        // },

    }
}
</script>
<style scoped>
.deviceCheck {
    padding: 100px;
}
.step1Box,
.step2Box,
.step3Box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 300px;
}
.step5Box {
    width: 100%;
    color: #666;
    font-size: 14px;
    text-align: center;
    padding: 80px 0;
}
.pass {
    color: #3CB371;
}
.userAgentBox {
    display: inline-block;
    color: red;
    padding: 20px 0;
}
.btnBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.step4Box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 300px;
}
.step2Content,
.step3Content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 190px;
}
.stream {
    width: 280px;
    height: 190px;
    margin: 15px 0;
    background-color: #000;
}
.el-select {
    width: 300px;
    margin: 15px 15px 0;
}
.step4Box .el-select {
    margin: 0px 15px;
}
.attention {
    display: inline-block;
    color: 	#FF0000;
    font-size: 15px;
    padding: 30px 0 15px;
}
.microphonesBox {
    width: 300px;
    padding: 20px 0;
}
.volumebar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
.el-progress {
    flex-basis: 260px;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/deviceCheck.vue